

import * as React from 'react'
import ManageFlags from '../../components/ManageFlags/ManageFlags'

const FlagManagement = () => {
  return (
    <div> 
     <ManageFlags/>
    </div>
  )
}

export default FlagManagement